<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="paramsNotas.estatus"
    persistent
    max-width="800"
  >
  	<v-card>
      <!-- PAGO OFICIAL -->
      <v-card-title>
        <span class="text-body-1"><b>Notas de la requisición</b></span>
        <v-spacer></v-spacer>
        <v-btn
          @click="paramsNotas.estatus = false"
          color="black"
          dark
          tile
          small
          class="text-capitalize"
        >
        	<v-icon left small>mdi-cancel</v-icon>
          Cancelar
        </v-btn>
      </v-card-title>
      <v-card-text >

      	<div v-for="(nota, i ) in notas" :key="i">
      		<label>{{ nota.nomuser }} - {{ nota.fecha_creacion }}</label>
	      	<v-textarea
	      		:value="nota.notas"
	      		readonly
	      		auto-grow
	      		rows="2"
	      		dense
	      		filled
	      	></v-textarea>
      	</div>

      	<v-textarea
      		v-model="nota"
      		auto-grow
      		rows="3"
      		dense
      		filled
      		label="Agregar notas"
      	></v-textarea>
      	<v-btn color="success" tile @click="agregarNota()">Agregar nota</v-btn>

      </v-card-text>
    </v-card>
    
    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-dialog>
</template>


<script>

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores         from '@/mixins/validarErrores'

  import { mapGetters, mapActions }  from 'vuex';

	export default {
		props:[
			'paramsNotas',
			'requisicion'
	  ],

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      notas:[],
      nota:''
      
    }),

    computed: {
      ...mapGetters('login', ['getdatosUsuario']),
      
    },

    async created() {

    	console.log( this.getdatosUsuario )
      
    	this.initialize()
    },


    methods: {
      // Inicio de todo
      initialize() {
        // Abrimos modal de carga
        this.cargar = true
        // Limpiamos los prospectos
        this.notas  = []

        
        this.$http.get('requisiciones.notas/' + this.requisicion.idrequisiciones ).then((response) => {
          // Filtramos los que necesitamos, depende si es vendedora o administrador
          this.notas = response.body
          // this.dialogRepote = true
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      	
      },

      agregarNota() {

      	if( this.nota == '' ){ return }
        // Abrimos modal de carga
        this.cargar = true
        // Limpiamos los prospectos
        this.notas  = []

        const payload = {
        	idusuario: this.getdatosUsuario.id, 
        	notas    : this.nota, 
        	idrequisiciones: this.requisicion.idrequisiciones
        }
        
        this.$http.post('requisiciones.notas', payload ).then((response) => {
          // Filtramos los que necesitamos, depende si es vendedora o administrador
          this.initialize()
          this.nota = ''
          // this.dialogRepote = true
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      	
      },


    },
  };
</script>
